<h1 mat-dialog-title>{{ "Please confirm" | cmLocalize: locFeature +
	"/_Shared.DeleteConfirmation.Title.Confirm" }}
</h1>
<div mat-dialog-content>
	<p *ngIf="!message">
		<span [cmLocalize]="locFeature + '/_Shared.DeleteConfirmation.Content.Question'">Are you sure you
			want to
			delete this
			item?</span>
	</p>
	<p *ngIf="message">
		{{ message }}
	</p>
</div>

<div mat-dialog-actions>
	<button mat-dialog-close>
		{{"Cancel" | cmLocalize: locFeature + "/_Shared.DeleteConfirmation.Button.Cancel"}}
	</button>
	<button [mat-dialog-close]="true" color="warn" cdkFocusInitial>
		{{"Confirm" | cmLocalize: locFeature + "/_Shared.DeleteConfirmation.Button.Confirm"}}
	</button>
</div>
